<template>
  <div class="bet-confirmation-detail">
    <div class="bet-confirmation-detail__header">
      <div class="bet-confirmation-detail__header__title">
        BET CONFIRMATION
      </div>
      <div class="bet-confirmation-detail__header__clear">
        <img
            @click="$parent.$emit('close')"
            class="bet-confirmation-detail__header__close"
            src="@/assets/images/ticket/remove.png"
        />
      </div>
    </div>
    <div class="bet-confirmation-detail__content">
      Book a bet ref #:202481
    </div>
    <div class="bet-confirmation-detail__buttons">
      <div
          @click="$parent.$emit('close')"
          class="bet-confirmation-detail__buttons__continue"
      >
        CONTINUE BETTING
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/ticket/betConfirmationDetail.scss"/>
